/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


import 'public/css/bootstrap.scss'
import 'public/css/fontawesome.scss'
import 'shared/css/tailwind.css';
import 'public/css/public.css'
import 'public/js/public.js'
import 'popper.js'
import 'public/js/piechart.js'
import 'dashboard/js/bower_components/jquery.easy-pie-chart/dist/jquery.easypiechart.js'
import 'jquery'
import 'bootstrap'
import 'dashboard/js/charts.js'

import 'public/img/contact.png'
import 'public/img/logo.png'
import 'public/img/peek_pro.png'
import 'public/img/logo-bird.png'

import 'public/img/logo-white.png'
import 'public/img/product-bg.png'
import 'public/img/profile-bg.png'
import 'public/img/profile-logo.png'
import 'public/img/icon-api-connected.png'
import 'public/img/lightning-icon.png'
import 'public/img/arrow-left.png'
import 'public/img/staticmap.png'
import 'public/img/landing_page/headout-logo.png'
import 'public/img/landing_page/headout-icon.png'
import 'public/img/landing_page/headout-1.png'
import 'public/img/landing_page/headout-2.png'
import 'public/img/landing_page/headout-3.png'
import 'public/img/landing_page/headout-arrow.png'

import 'public/img/locations/san-francisco.svg'
import 'public/img/landing_page/where-travel-web.png'
import 'public/img/landing_page/hiw1-rp.jpg'
import 'public/img/landing_page/hiw2-rp.jpg'
import 'public/img/landing_page/hiw3-rp.jpg'
import 'public/img/landing_page/hiw4-rp.jpg'
import 'public/img/landing_page/wt-what-is-magpie.png'
import 'public/img/landing_page/GettinLocal-1.png'
import 'public/img/landing_page/GettinLocal-2.jpg'
import 'public/img/landing_page/GettinLocal-4.png'

import 'public/img/sponsors/Arival-Logo-White.jpg'
import 'public/img/sponsors/Tour.jpg'
import 'public/img/sponsors/tripschool.png'
import 'public/img/sponsors/ventatra.jpg'
import 'public/img/walks-logo.png'
import 'public/img/banner.png'
import 'public/img/operator-banner.png'
import 'public/img/operator-banner.jpg'
import 'public/img/tripadvisor_background.svg'
import 'public/img/background_header.png'
import 'public/img/google-round-01.svg'
import 'public/img/facebook-round-01.svg'
import 'public/img/instagram-round-01.svg'
import 'public/img/linkedin-round-01.svg'
import 'public/img/tiktok-round-01.svg'
import 'public/img/tripadvisor-round-01.svg'
import 'public/img/twitter-round-01.svg'
import 'public/img/youtube-round-01.svg'
import 'public/img/google-ttd-01.svg'
import 'public/img/chatbot.png'
import 'public/img/icons-user.png'
import 'public/img/chatbot-icon-magpie.png'

import 'public/img/expedia-favicon-01.svg'
import 'public/img/google-favicon-01.svg'
import 'public/img/getyourguide-favicon-01.svg'
import 'public/img/tripadvisor-favicon-01.svg'
import 'public/img/viator-favicon-01.svg'

import 'public/img/expedia-review-widget-01.svg'
import 'public/img/google-review-widget-01.svg'
import 'public/img/getyourguide-review-widget-01.svg'
import 'public/img/tripadvisor-review-widget-01.svg'
import 'public/img/viator-review-widget-01.svg'
import 'public/img/musement-review-widget-01.svg'



import 'public/img/expedia-review-widget-02.svg'
import 'public/img/google-review-widget-02.svg'
import 'public/img/getyourguide-review-widget-02.svg'
import 'public/img/tripadvisor-review-widget-02.svg'
import 'public/img/viator-review-widget-02.svg'
import 'public/img/market_pulse/market_pulse-1.svg'
import 'public/img/market_pulse/market_pulse-2.svg'
import 'public/img/market_pulse/market_pulse-3.svg'
import 'public/img/madame-tussauds-logo.svg'
import 'public/img/city-experiences-logo.svg'
import 'public/img/big-bus-tours-logo.svg'
import 'public/img/san-diego-zoo-logo.svg'
import 'public/img/london-eye-logo.svg'
import 'public/img/go-city-logo.svg'
import 'public/img/top-of-the-rock-logo.svg'
import 'public/img/skyline-new-logo.svg'
import 'public/img/maverick-logo.svg'
import 'public/img/city-wonders-logo.svg'
import 'public/img/one-world-observatory-logo.svg'

import 'public/img/expedia-review-icon-01.svg'
import 'public/img/google-review-icon-01.svg'
import 'public/img/getyourguide-review-icon-01.svg'
import 'public/img/tripadvisor-review-icon-01.svg'
import 'public/img/viator-review-icon-01.svg'
import 'public/img/affiliate-image-default.jpg'
import 'public/img/x-round-01.svg'

require('@rails/ujs').start()

// TODO: Remove when we remove the remaining "Gallery" React.js component
var componentRequireContext = require.context("components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)
